import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import config from "../../config";

function CommercialApproval() {
  const navigate = useNavigate();
  const { repoId } = useParams();

  const decodedRepoId = repoId ? atob(repoId) : "";

  // Logged In User
  const userId = useSelector((state) => state.userInfo.id);

  const API_SERVER = config.API_BASE_URL;

  const [loading, setLoading] = useState(true);
  const [postLoading, setPostLoading] = useState(false);

  const [repoData, setRepoData] = useState(null);

  const [formData, setFormData] = useState({
    rto_charges_by: "",
    challan_status: "No",
    challan_amount: "",
    insurance_validity: "Yes",
    fitness_validity: "Yes",
    other_expenses: "No",
    other_expenses_amount: "",
    notes: "",
  });

  useEffect(() => {
    getRepoData();
  }, []);

  const getRepoData = async () => {
    try {
      const res = await axios.get(
        `${API_SERVER}getVehicleRepoById/${decodedRepoId}`
      );

      if (res.data.status && res.data.data) {
        setRepoData(res.data.data);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    try {
      setPostLoading(true);

      const payload = {
        repo_id: decodedRepoId,
        agreement_no: repoData?.agreement_no,
        customer_name: repoData?.customer_name,
        mobile: repoData?.mobile,
        vehicle_number: repoData?.registration_number,
        make: repoData?.make,
        model: repoData?.model,
        city: repoData?.city,

        rto_charges_by: formData.rto_charges_by,
        challan_status: formData.challan_status,
        challan_amount: formData.challan_amount,
        insurance_validity: formData.insurance_validity,
        fitness_validity: formData.fitness_validity,
        other_expenses: formData.other_expenses,
        other_expenses_amount: formData.other_expenses_amount,
        notes: formData.notes,

        user_id: userId,
      };

      const res = await axios.post(
        `${API_SERVER}saveCommercialApproval`,
        payload
      );

      if (res.data.status) {
        toast.success(res.data.message);

        navigate("/dashboard/vehicle-repo-list");
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.message || "Something went wrong"
      );
    } finally {
      setPostLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="container-fluid">
        Loading...
      </div>
    );
  }

  return (
    <div className="container mt-4">

      <div className="card shadow-sm">

        <div className="card-header">
          <h4>Commercial Approval</h4>
        </div>

        <div className="card-body">

          <div className="row">

            <div className="col-md-6 mb-3">
              <label>Customer Name</label>
              <input
                className="form-control"
                value={repoData?.customer_name || ""}
                readOnly
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>Loan Number</label>
              <input
                className="form-control"
                value={repoData?.agreement_no || ""}
                readOnly
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>Mobile Number</label>
              <input
                className="form-control"
                value={repoData?.mobile || ""}
                readOnly
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>Vehicle Number</label>
              <input
                className="form-control"
                value={repoData?.registration_number || ""}
                readOnly
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>Make</label>
              <input
                className="form-control"
                value={repoData?.make || ""}
                readOnly
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>Model</label>
              <input
                className="form-control"
                value={repoData?.model || ""}
                readOnly
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>City</label>
              <input
                className="form-control"
                value={repoData?.city || ""}
                readOnly
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>RTO Charges Borne By</label>
              <select
                className="form-control"
                name="rto_charges_by"
                value={formData.rto_charges_by}
                onChange={handleChange}
              >
                <option value="">Select</option>
                <option value="Customer">Customer</option>
                <option value="Ckers">Ckers</option>
              </select>
            </div>

            <div className="col-md-6 mb-3">
              <label>Challan Status</label>
              <select
                className="form-control"
                name="challan_status"
                value={formData.challan_status}
                onChange={handleChange}
              >
                <option value="No">No</option>
                <option value="Yes">Yes</option>
              </select>
            </div>

            <div className="col-md-6 mb-3">
              <label>Challan Amount</label>
              <input
                type="number"
                className="form-control"
                name="challan_amount"
                value={formData.challan_amount}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>Insurance Validity</label>
              <select
                className="form-control"
                name="insurance_validity"
                value={formData.insurance_validity}
                onChange={handleChange}
              >
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>

            <div className="col-md-6 mb-3">
              <label>Fitness Validity</label>
              <select
                className="form-control"
                name="fitness_validity"
                value={formData.fitness_validity}
                onChange={handleChange}
              >
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>

            <div className="col-md-6 mb-3">
              <label>Other Expenses</label>
              <select
                className="form-control"
                name="other_expenses"
                value={formData.other_expenses}
                onChange={handleChange}
              >
                <option value="No">No</option>
                <option value="Yes">Yes</option>
              </select>
            </div>

            <div className="col-md-6 mb-3">
              <label>Other Expenses Amount</label>
              <input
                type="number"
                className="form-control"
                name="other_expenses_amount"
                value={formData.other_expenses_amount}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-12 mb-3">
              <label>Notes</label>
              <textarea
                className="form-control"
                rows="3"
                name="notes"
                value={formData.notes}
                onChange={handleChange}
              />
            </div>

          </div>

          <div className="text-end">

            <button
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={postLoading}
            >
              {postLoading ? "Submitting..." : "Submit"}
            </button>

          </div>

        </div>

      </div>

    </div>
  );
}

export default CommercialApproval;

